import { render, staticRenderFns } from "./AlternativeAudioUploader.vue?vue&type=template&id=553e234d&scoped=true&"
import script from "./AlternativeAudioUploader.vue?vue&type=script&lang=js&"
export * from "./AlternativeAudioUploader.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeAudioUploader.vue?vue&type=style&index=0&id=553e234d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e234d",
  null
  
)

export default component.exports